// export const find = (arr, slug) => arr.find(f => f === f.slug)
export const formatMessage = (error) => {
  return (
    error?.response.data ||
    (error?.response && error.response.data && error?.response.data.message) ||
    error?.message ||
    error.toString()
  );
};

export const addEllipses = (description, maxLength) => {
  if (description?.length > maxLength) {
    description = description?.substring(0, maxLength);
    const lastSpaceIndex = description?.lastIndexOf(" ");
    if (lastSpaceIndex !== -1) {
      description = description?.substring(0, lastSpaceIndex) + "...";
    } else {
      description += "...";
    }
  }
  return description;
};

export function isEmptyObjectValues(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      if (value === "" || (typeof value === "object" && isEmpty(value))) {
        return true; // Found an empty value
      }
    }
  }
  return false; // No empty values found
}

export function isEmpty(value) {
  if (value === null) return true;
  if (Array.isArray(value)) {
    return value.length === 0; // Check if array is empty
  } else if (typeof value === "object" && value !== null) {
    return Object.keys(value).length === 0; // Check if object is empty
  } else {
    return value === ""; // Check if string is empty
  }
}

export function objectCheck(obj) {
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false; // Found a property in the nested object, it's not empty
    }
  }
  return true; // No properties found, it's an empty object
}

// for checking and returning the key for which value is empty
export const getEmptyKey = (obj) => {
  for (const key in obj) {
    if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
      return key?.split("_").join(" "); // return key with empty value
    } else if (typeof obj[key] === "object") {
      const nestedEmptyKey = getEmptyKey(obj[key]); // recursively check nested object
      if (nestedEmptyKey) {
        return `${key}.${nestedEmptyKey}`; // prepend key with nested empty key
      }
    }
  }
  return null; // return null if no empty key found
};

// check if object is empty 'it returns true or false'
export const isEmptyObject = (obj) => {
  if (obj === null) return true;
  return Object.keys(obj).length === 0;
};

// remove leading zeros from input number
export const removeLeadingZeros = (value) => {
  var input = document.getElementById(value);
  input.value = input.value.replace(/^0+/, "");
};

export const convertDate = (dateString) => {
  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  const day = dateObj.getDate().toString().padStart(2, "0");
  return `${month}-${day}-${year}`;
};
